module.exports = __webpack_public_path__ + "static/media/DResort-Booking.c1eb414e.jpg";